import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialOpenAiIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialOpenAi",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.616 12.352a8.14 8.14 0 0 0-2.108-7.86 8.13 8.13 0 0 0-7.86-2.108 8.13 8.13 0 0 0-7.86-2.105 8.13 8.13 0 0 0-5.756 5.753A8.13 8.13 0 0 0 .28 11.788a8.13 8.13 0 0 0 2.105 7.86 8.14 8.14 0 0 0 2.108 7.86 8.13 8.13 0 0 0 7.86 2.108 8.13 8.13 0 0 0 7.86 2.105 8.13 8.13 0 0 0 5.756-5.753 8.13 8.13 0 0 0 5.753-5.756 8.13 8.13 0 0 0-2.105-7.86M26.2 5.799a6.28 6.28 0 0 1 1.785 5.29L21.21 7.178a.92.92 0 0 0-.923 0l-7.934 4.58V8.755c0-.21.113-.408.295-.513l6.042-3.489A6.29 6.29 0 0 1 26.201 5.8M16 11.787l3.648 2.107v4.212L16 20.213l-3.649-2.107v-4.212zm-8.396-3.74A6.292 6.292 0 0 1 17.74 3.164l-6.777 3.913a.92.92 0 0 0-.461.8v9.161L7.9 15.536a.6.6 0 0 1-.296-.512zm-5.539 4.22a6.28 6.28 0 0 1 3.69-4.192V15.9c0 .33.175.635.46.8l7.935 4.58-2.601 1.503a.6.6 0 0 1-.592 0l-6.042-3.488a6.29 6.29 0 0 1-2.85-7.029M5.8 26.2a6.28 6.28 0 0 1-1.785-5.29l6.776 3.912a.92.92 0 0 0 .924 0l7.934-4.58v3.003c0 .21-.113.408-.295.513l-6.042 3.489A6.29 6.29 0 0 1 5.799 26.2m18.597-2.248a6.292 6.292 0 0 1-10.136 4.883l6.776-3.913a.92.92 0 0 0 .462-.8v-9.161l2.602 1.502a.6.6 0 0 1 .296.512zm5.539-4.22a6.28 6.28 0 0 1-3.69 4.192V16.1a.92.92 0 0 0-.46-.8l-7.936-4.58 2.602-1.503a.6.6 0 0 1 .592 0l6.042 3.488a6.29 6.29 0 0 1 2.85 7.029"
    })
  }));
};
SocialOpenAiIcon.displayName = 'SocialOpenAiIcon';